import React, { type FC } from "react";
import "./AboutSystem.scss";
import Version from "../../components/service/Version/Version";
import { CardHeader } from "@shared/ui/card-header";

export const AboutSystem: FC = () => {
    return (
        <div className="about_system_page">
            <CardHeader className="about_system_page_header" text="О системе" />
            <div className="about_system_page_content">
                <div className="version_info custom_scrollbar">
                    <Version />
                </div>
            </div>
        </div>
    );
};
